module.exports = __webpack_public_path__ + "static/media/LegendOfEgypt_EN.8a06605f.png";